import type { SupabaseClient } from '../client'
import type { Database } from '../database.types'

export type TeamMember = {
  id: Database['portal']['Tables']['client_users']['Row']['id']
  name: string
  email: string
  avatar_url: string | null
  role: string
  active: boolean
  last_login_at: string | null
  access_level: string
  granted_at: string
  /** Escopo, como leitura: o cliente ve, e quem muda e a equipe. */
  projeto_inteiro: boolean
  iniciativas: number
}

/**
 * Lista os membros do cliente que tem acesso ao projeto. Chama RPC
 * `portal.list_project_team` (SECURITY DEFINER) porque o RLS de
 * client_project_access/client_users so devolve a row do proprio user,
 * o que escondia os teammates do mesmo projeto.
 */
export async function listProjectTeam(
  client: SupabaseClient,
  projectId: number,
): Promise<TeamMember[]> {
  const { data, error } = await client
    .schema('portal')
    .rpc('list_project_team', { p_project_id: projectId })
  if (error) throw error
  return (data || []) as TeamMember[]
}
